import { IonChip, IonIcon, IonLabel } from '@ionic/react'
import { useQuery } from '@tanstack/react-query'
import { useGate, useStore, useStoreMap } from 'effector-react'
import { bulb } from 'ionicons/icons'
import { informationCircleOutline } from 'ionicons/icons'
import { useEffect, useMemo, useState } from 'react'
import { useDebounce } from 'use-debounce'
import { PayInfoModal, WithdrawalForm, balanceModel } from '~/entities/Balance'
import { setCommission } from '~/entities/Balance/model'
import { Payout, PayoutCommission } from '~/shared/api'
import { STATUS_VARIANT } from '~/shared/config/constants'
import { useModal } from '~/shared/ui/Modal'
import { Wrapper, Row } from './styled'
import { AmountAll } from './ui/AmountAll'
import { Commission } from './ui/Commission'
import { LoadingBlock } from './ui/LoadingBlock'
import { SelectedPayCard } from './ui/SelectedPayCard'

export function Content() {
  useGate(balanceModel.Gate)

  const { isModalShow, openModal, closeModal } = useModal()
  const [amount, setAmount] = useState<number>()

  const isPayCardsPending = useStore(balanceModel.getPayCardsFx.pending)
  const isAmountAllLoading = useStore(balanceModel.getAvailableFundsFx.pending)
  const availableFunds = useStore(balanceModel.$availableFunds)
  const isTransactionCanPending = useStore(
    balanceModel.transactionCanFx.pending,
  )
  const selectedPayCard = useStoreMap(
    balanceModel.$selectedPayCard,
    (payCard) => payCard?.getAttributes(),
  )

  const gridKey = useMemo(
    () => ['getWithdrawalCommission', amount, selectedPayCard],
    [amount, selectedPayCard],
  )

  const [debounceGridKey] = useDebounce(gridKey, 400)

  const { data: resCommission, isFetching } = useQuery<PayoutCommission>(
    debounceGridKey,
    () =>
      Payout.commission({
        amount: amount as number,
        bankCardId: selectedPayCard?.bankCardId as UniqueId,
      }),
    {
      enabled: Boolean(amount && selectedPayCard?.bankCardId),
      retry: false,
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      cacheTime: 0,
    },
  )

  useEffect(() => {
    setCommission(resCommission && amount ? resCommission : null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resCommission])

  if (isPayCardsPending) return <LoadingBlock />

  return (
    <>
      <Wrapper>
        <Row>
          <div style={{ fontSize: '12px' }}>Доступно к снятию в сутки</div>
          <IonIcon
            icon={informationCircleOutline}
            onClick={openModal}
            style={{
              width: '24px',
              height: '24px',
              cursor: 'pointer',
              marginLeft: '5px',
            }}
            size='small'
          />
        </Row>

        <AmountAll />
      </Wrapper>

      <div style={{ fontSize: '16px', marginBottom: '16px' }}>
        Вывести на карту:
      </div>

      <SelectedPayCard />

      {selectedPayCard && (
        <WithdrawalForm
          isSubmitting={isFetching || isTransactionCanPending}
          onSuccess={balanceModel.transactionCan}
          amountAll={availableFunds?.amountWithCommission || 0}
          isAmountAllLoading={isAmountAllLoading}
          onSumChange={setAmount}
          disable={!resCommission}
          additionalContent={<Commission isLoading={isFetching} />}
        />
      )}

      {!selectedPayCard && (
        <IonChip style={{ ...STATUS_VARIANT['yellow'] }}>
          <IonIcon
            icon={bulb}
            style={{ fill: STATUS_VARIANT['yellow'].color }}
          />
          <IonLabel>
            Для расчета комиссии и вывода средств добавьте или выберите
            банковскую карту
          </IonLabel>
        </IonChip>
      )}

      <PayInfoModal isShow={isModalShow} onCancel={closeModal} />
    </>
  )
}
